export interface PublicConfig {
  tracking: {
    gtmContainerId: string;
    metaPixelId: string;
  };
}

export async function fetchPublicConfig(): Promise<PublicConfig> {
  const response = await fetch("/api/public-config", { headers: { accept: "application/json" } });
  if (!response.ok) throw new Error(`Public config failed with ${response.status}`);
  return (await response.json()) as PublicConfig;
}
